import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertTriangle } from "lucide-react";

interface PaidAccessFileReplaceNoticeProps {
  show: boolean;
}

export function PaidAccessFileReplaceNotice({ show }: PaidAccessFileReplaceNoticeProps) {
  if (!show) return null;

  return (
    <Alert variant="warning" className="flex gap-3">
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-amber-700" />
      <div>
        <p className="mb-1 font-semibold text-amber-950">Paid access in effect</p>
        <AlertDescription>
          Patrons have already purchased or claimed access. Replacing the underlying PDF (re-upload
          or storage change) will change what future downloads receive for existing entitlements.
          Prefer publishing a new resource if you need a different edition.
        </AlertDescription>
      </div>
    </Alert>
  );
}
